import React, { Component } from 'react'
import { Header } from 'semantic-ui-react'

class Unauthorized extends Component {
  render() {
    return (
      <div>
        <Header as="h1">Erreur 401</Header>
        <p>Vous n'avez l'accès à cette ressource.</p>
      </div>
    )
  }
}

export default Unauthorized



// WEBPACK FOOTER //
// ./src/components/Unauthorized.js